'use client'

import classNames from 'classnames'
import React from 'react'
import { ProductTypeProps } from '.'

import { DigitalDataOrigin, ProductWithCategoryType } from '../utils/digital-data-types'
import { useTrackingOnScreen } from '@dustin-web/microsite-components/src/on-screen/'
import { Card } from './product-card-gallery-composable'
import { getProductLabels } from './utils'
import { ProductDigitalData } from '../utils/product-digital-data'
import ProductPrice from '../product-price'
import { EllipsisOrNot } from './../product-card-title/product-card-title'

type Props = {
  imagePriority?: boolean
  product?: any // todo: fix type
  ticket: string
  digitalDataOrigin: DigitalDataOrigin
  digitalIndex?: number
  showAddToCartButton?: boolean
  sizeClasses?: string
  className?: string
}

const ProductVariantCardCombination = ({
  product,
  ticket,
  imagePriority = false,
  digitalDataOrigin,
  digitalIndex = 0,
  sizeClasses,
  className,
}: Props) => {
  if (!product) {
    return null
  }

  return (
    <Container
      sizeClasses={sizeClasses}
      digitalIndex={digitalIndex}
      product={product}
      digitalDataOrigin={digitalDataOrigin}
      className={className}>
      <Card.Picture
        className="u-mr-12"
        product={product}
        ticket={ticket}
        imageWidth={64}
        imageHeight={48}
        imagePriority={imagePriority}
        digitalDataIndex={digitalIndex}
        digitalDataOrigin={digitalDataOrigin}
      />
      <div
        className={`c-product-card__product-info d-flex ${
          product.availability?.isAvailableForSale ? 'u-mr-12' : ''
        }`}>
        <div className="u-w-100">
          <div className="flex-fill ">
            <Card.Title
              product={{ ...product, displaySpecifications: '' }} // no good, fix later
              ticket={ticket}
              digitalDataIndex={digitalIndex}
              digitalDataOrigin={digitalDataOrigin}
              compact
              ellipsis
            />
            <div className="u-fw-bold u-pt-4">
              <EllipsisOrNot ellipsis text={product.displaySpecificationsVariantC} />
            </div>
          </div>

          <div className="d-flex u-pt-8">
            <Card.Availability
              availability={product.availability}
              isBid={product.price?.isBid}
              className="u-pb-4 u-relative"
              listForm
              defaultContainerClassName="d-flex"
            />
          </div>
        </div>
        <div className="align-items-center d-flex justify-content-center">
          <ProductPrice price={product.price} displayVatInfo={false} />
        </div>
      </div>
    </Container>
  )
}

type ContainerProps = {
  children: React.ReactNode
  sizeClasses: Props['sizeClasses']
  digitalIndex: number
  product: Props['product']
  digitalDataOrigin: Props['digitalDataOrigin']
  className?: string
}

function pushViewItemList(
  digitalIndex?: number,
  digitalDataOrigin?: DigitalDataOrigin,
  product?: ProductWithCategoryType | ProductTypeProps | null
) {
  if (product && digitalDataOrigin && digitalIndex !== (undefined || null)) {
    ProductDigitalData.pushViewItemList(
      [
        {
          ...product,
          productListIndex: digitalIndex,
          label: getProductLabels(product as ProductTypeProps),
        },
      ] as ProductWithCategoryType[],
      digitalDataOrigin
    )
  }
}

const Container = ({
  children,
  sizeClasses,
  digitalIndex,
  product,
  digitalDataOrigin,
  className,
}: ContainerProps) => {
  const ref = useTrackingOnScreen(() => pushViewItemList(digitalIndex, digitalDataOrigin, product))

  return (
    <div
      ref={ref}
      className={classNames(
        className,
        sizeClasses,
        'c-product-card c-product-card--variants t-nullify u-overflow-hidden u-border u-border-dark-gray'
      )}>
      {children}
    </div>
  )
}

export default ProductVariantCardCombination
